/* eslint-disable */
import { Warning } from '@mui/icons-material';
import toast from 'react-hot-toast';
import authActions from '../Actions/auth.actions';
import { store } from '../Helpers';

const notificationServices = {
	generateNotification,
	closeNotification,
};
function closeNotification(notificationId) {
	if (notificationId) {
		toast.dismiss(notificationId);
		store.dispatch(authActions.toggleLoading(false));
	}
}

function generateNotification({ type, customMessage = false, message, config = {} }) {
	let notificationId = null;
	if (config.id) {
		store.dispatch(authActions.toggleLoading(false));
	}

	if (typeof message === 'object') {
		return null;
	}
	switch (type) {
		case 'info':
			notificationId = toast.custom(
				customMessage ? message : (
					<div className='bg-white rounded-md shadow-sm p-3 text-slate-700 text-[13px]'>
						{message}
					</div>)
				,
				{
					...config,
				}
			);
			break;
		case 'success':
			notificationId = toast.success(message, {
				...config,
			});
			break;
		case 'error':
			notificationId = toast.error(message, {
				...config,
			});
			break;
		case 'loading':
			store.dispatch(authActions.toggleLoading(true));
			notificationId = toast.loading(message, {
				...config,
			});
			break;
		case 'warning':
			notificationId = toast(message, {
				icon: (
					<Warning
						style={{
							color: '#ffc107',
						}}
					/>
				),
				...config,
			});
			break;
		case 'wave':
			notificationId = toast(message, {
				icon: '👏',
				...config,
			});
			break;
		default:
			notificationId = toast(message, {
				...config,
			});
			break;
	}
	return notificationId;
}

export default notificationServices;
